// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customer-information__email{\n    width: 100%;\n    margin-bottom: 8px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/guest-customer/guestCustomer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".customer-information__email{\n    width: 100%;\n    margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
